import React from 'react';

type Direction = 'right' | 'left' | 'up' | 'down';

interface Props {
  onButtonClick: () => void;
  direction?: Direction;
  disabled?: boolean;
  title?: string;
}

const directionToRotation: Record<Direction, string> = {
  right: '', // No rotation for 'right' as it is the default orientation
  left: 'rotate-180', // 180 degrees rotation for 'left'
  down: 'rotate-90', // 90 degrees rotation counter-clockwise for 'up'
  up: '-rotate-90', // 90 degrees rotation clockwise for 'down'
};

export const ChevronButton: React.FC<Props> = ({ onButtonClick, direction = 'right', disabled = false, title }) => {
  return (
    <button
      type="button"
      title={title ? title : direction}
      onClick={onButtonClick}
      className={`${disabled && 'opacity-50'}`}
      disabled={disabled}
    >
      <img
        className={`w-[2rem] ${directionToRotation[direction]}  `}
        title="left"
        src="/assets/icons/flat/chevron-right_purple.svg"
      ></img>
    </button>
  );
};
